import { render, staticRenderFns } from "./MembershipLockChip.vue?vue&type=template&id=3e5375c2&scoped=true&"
import script from "./MembershipLockChip.vue?vue&type=script&lang=js&"
export * from "./MembershipLockChip.vue?vue&type=script&lang=js&"
import style0 from "./MembershipLockChip.vue?vue&type=style&index=0&id=3e5375c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5375c2",
  null
  
)

export default component.exports